import { createContext } from "react";

import type { AuthActions } from "@/features/auth/shared/auth-actions";
import type { User } from "@/lib/auth/auth-api";

export interface AuthContextValue extends AuthActions {
  user: User | null;
  /** True only while the initial `fetchMe` bootstrap (on mount) is in flight. */
  isLoading: boolean;
  isAuthenticated: boolean;
}

export const AuthContext = createContext<AuthContextValue | undefined>(undefined);
